import { CSSObject } from "@emotion/react";
const coreBlue = { 700: "#0052C4", 500: "#106FF3" };

export const wrapper: CSSObject = {
  height: "100%",
  margin: "0 auto",
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

export const wrapperPrinted: CSSObject = {
  ...wrapper,
  maxWidth: "816px",
  maxHeight: "956px",
};

export const directions: CSSObject = {
  fontSize: "0.75em",
  lineHeight: "normal",
};

export const kwlSection: CSSObject = {
  flex: "1 1 60%",
  display: "flex",
  border: `4px solid ${coreBlue[500]}`,
  borderRadius: "30px",
  overflow: "hidden",
  height: "100%",
};

export const kwlInnerSection: CSSObject = {
  width: "33.33%",
  boxSizing: "border-box",
  padding: "0 10px 10px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  borderRight: `4px solid ${coreBlue[500]}`,
  minHeight: "55vh",
};

export const kwlHeader: CSSObject = {
  fontSize: "0.9em",
  textAlign: "center",
  margin: "10px",
  borderBottom: `4px solid ${coreBlue[500]}`,
  width: "50%",
  paddingBottom: "5px",
};

export const kwlTextArea: CSSObject = {
  width: "100%",
  height: "100%",
  boxSizing: "border-box",
  resize: "none",
  fontFamily: "inherit",
  overflow: "hidden",
  fontSize: "0.75em",
  padding: "5px",
  margin: "0",
};

export const kwlTextAreaPrinted: CSSObject = {
  ...kwlTextArea,
  height: "100%",
};

export const kwlSectionInput: CSSObject = {
  fontSize: "0.9em",
  margin: "0",
};
